import PropTypes from 'prop-types';

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
} from '@chakra-ui/react';
import NavigationContent from './NavigationContent';

function SideNavigationSm({ isOpen, onClose, id }) {
  return (
    <Drawer onClose={onClose} isOpen={isOpen} size="sm">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerBody my={10}>
          <NavigationContent id={id} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

SideNavigationSm.propTypes = {
  id: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SideNavigationSm;
